export default "__VITE_ASSET__BYKGNXFP__"